import React from 'react';
import classNames from 'classnames';

import styles from './select-radio-indicator.module.scss';

export type SelectRadioIndicatorProps = {
  soldOut?: boolean;
  active?: boolean;
};

export const SelectRadioIndicator = ({ soldOut, active }: SelectRadioIndicatorProps) => (
  <span
    className={classNames(styles.selectRadioIndicator, 'selectRadioIndicator', {
      [styles.soldOut]: soldOut,
      [styles.active]: active,
    })}
  >
    <span className={classNames(styles.selectRadioIndicatorDot, 'selectRadioIndicatorDot')} />
  </span>
);
